import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ButtonCopyText } from '@components/atoms/button-copy-text';
import { Typography } from '@components/atoms/typography';
import { QrCode } from '@components/moleculs/qr-code';
import { TextField } from '@components/moleculs/text-field';
import type { RootState } from '@store/root-reducer';

import { DesktopNotAllowedContainer } from './styles';

export const DesktopNotAllowedStep: React.FC = () => {
    const { t } = useTranslation();
    const verificationUrl =
        useSelector((state: RootState) => state.docsVerification.sdkOptions?.verificationUrl) || '';

    return (
        <DesktopNotAllowedContainer>
            <div className='not-allowed-container'>
                <Typography tag='h2' variant='h2' className='title'>
                    {t('docVerificationWizard.desktopNotAllowed.title')}
                </Typography>
                <Typography tag='div' variant='text-bold' color='text-light' className='sub-title'>
                    {t('docVerificationWizard.qrLink.text')}
                </Typography>
                <div className='qr-container'>
                    <QrCode value={verificationUrl} size={135} />
                </div>
                <TextField
                    disabled={true}
                    fullWidth={true}
                    value={verificationUrl}
                    InputProps={{
                        endAdornment: (
                            <ButtonCopyText
                                copyText={verificationUrl}
                                tooltipProps={{
                                    title: t('common.copied'),
                                    placement: 'bottom',
                                }}
                                className='icon'
                            />
                        ),
                    }}
                    inputSize='m'
                    className='link-field'
                />
            </div>
        </DesktopNotAllowedContainer>
    );
};
